// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: oyxikxJz0w
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { useScreenVariants as useScreenVariantsrrBukHdQcoc } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: rrBukHDQcoc/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicRadialSummary.module.css"; // plasmic-import: oyxikxJz0w/css
import images2FdubaiPngChihQbGd6TnF from "./images/images2FdubaiPng.png"; // plasmic-import: chihQBGd6tnF/picture

createPlasmicElementProxy;

export const PlasmicRadialSummary__VariantProps = new Array(
  "notWrapped",
  "leftAligned",
  "nobox",
  "showButton"
);

export const PlasmicRadialSummary__ArgProps = new Array(
  "cityH1",
  "cityLink",
  "numBrands",
  "numLocations",
  "cityMapImgProp"
);

const $$ = {};

function PlasmicRadialSummary__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          cityMapImgProp: {
            src: images2FdubaiPngChihQbGd6TnF,
            fullWidth: 1100,
            fullHeight: 733,
            aspectRatio: undefined
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "notWrapped",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.notWrapped
      },
      {
        path: "leftAligned",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.leftAligned
      },
      {
        path: "nobox",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.nobox
      },
      {
        path: "showButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.showButton
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsrrBukHdQcoc()
  });
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        {
          [sty.rootleftAligned]: hasVariant(
            $state,
            "leftAligned",
            "leftAligned"
          ),
          [sty.rootnobox]: hasVariant($state, "nobox", "nobox"),
          [sty.rootnotWrapped]: hasVariant($state, "notWrapped", "notWrapped")
        }
      )}
    >
      <PlasmicLink__
        data-plasmic-name={"cityLink"}
        data-plasmic-override={overrides.cityLink}
        className={classNames(projectcss.all, projectcss.a, sty.cityLink, {
          [sty.cityLinkleftAligned]: hasVariant(
            $state,
            "leftAligned",
            "leftAligned"
          ),
          [sty.cityLinknobox]: hasVariant($state, "nobox", "nobox"),
          [sty.cityLinknotWrapped]: hasVariant(
            $state,
            "notWrapped",
            "notWrapped"
          )
        })}
        href={args.cityLink}
        platform={"react"}
      >
        <div className={classNames(projectcss.all, sty.freeBox__fEIdX)}>
          <div className={classNames(projectcss.all, sty.freeBox___2Hv6W)}>
            <Stack__
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__hvkXe, {
                [sty.freeBoxleftAligned__hvkXErUgth]: hasVariant(
                  $state,
                  "leftAligned",
                  "leftAligned"
                ),
                [sty.freeBoxnotWrapped__hvkXekenmz]: hasVariant(
                  $state,
                  "notWrapped",
                  "notWrapped"
                )
              })}
            >
              <div
                data-plasmic-name={"mapImg"}
                data-plasmic-override={overrides.mapImg}
                className={classNames(projectcss.all, sty.mapImg)}
              >
                <PlasmicImg__
                  data-plasmic-name={"img"}
                  data-plasmic-override={overrides.img}
                  alt={""}
                  className={classNames(sty.img)}
                  displayHeight={"80px"}
                  displayMaxHeight={"100px"}
                  displayMaxWidth={"100px"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"80px"}
                  loading={"lazy"}
                  src={args.cityMapImgProp}
                />
              </div>
              <div
                className={classNames(projectcss.all, sty.freeBox__jSk8K, {
                  [sty.freeBoxleftAligned__jSk8KrUgth]: hasVariant(
                    $state,
                    "leftAligned",
                    "leftAligned"
                  )
                })}
              >
                <h1
                  data-plasmic-name={"cityH1"}
                  data-plasmic-override={overrides.cityH1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    sty.cityH1,
                    {
                      [sty.cityH1leftAligned]: hasVariant(
                        $state,
                        "leftAligned",
                        "leftAligned"
                      )
                    }
                  )}
                >
                  {renderPlasmicSlot({
                    defaultContents: "Boston",
                    value: args.cityH1,
                    className: classNames(sty.slotTargetCityH1, {
                      [sty.slotTargetCityH1leftAligned]: hasVariant(
                        $state,
                        "leftAligned",
                        "leftAligned"
                      ),
                      [sty.slotTargetCityH1notWrapped]: hasVariant(
                        $state,
                        "notWrapped",
                        "notWrapped"
                      )
                    })
                  })}
                </h1>
                <div
                  data-plasmic-name={"numBrands"}
                  data-plasmic-override={overrides.numBrands}
                  className={classNames(projectcss.all, sty.numBrands, {
                    [sty.numBrandsleftAligned]: hasVariant(
                      $state,
                      "leftAligned",
                      "leftAligned"
                    )
                  })}
                >
                  {renderPlasmicSlot({
                    defaultContents: "36 brands",
                    value: args.numBrands,
                    className: classNames(sty.slotTargetNumBrands, {
                      [sty.slotTargetNumBrandsleftAligned]: hasVariant(
                        $state,
                        "leftAligned",
                        "leftAligned"
                      )
                    })
                  })}
                </div>
                <div
                  data-plasmic-name={"numLocations"}
                  data-plasmic-override={overrides.numLocations}
                  className={classNames(projectcss.all, sty.numLocations)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "2000+ locations",
                    value: args.numLocations,
                    className: classNames(sty.slotTargetNumLocations)
                  })}
                </div>
                <button
                  data-plasmic-name={"greenButton3"}
                  data-plasmic-override={overrides.greenButton3}
                  className={classNames(
                    projectcss.all,
                    projectcss.button,
                    sty.greenButton3,
                    {
                      [sty.greenButton3showButton]: hasVariant(
                        $state,
                        "showButton",
                        "showButton"
                      )
                    }
                  )}
                  ref={ref => {
                    $refs["greenButton3"] = ref;
                  }}
                >
                  <div
                    data-plasmic-name={"text"}
                    data-plasmic-override={overrides.text}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text
                    )}
                  >
                    {"View Brands"}
                  </div>
                </button>
              </div>
            </Stack__>
          </div>
        </div>
      </PlasmicLink__>
    </button>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "cityLink",
    "mapImg",
    "img",
    "cityH1",
    "numBrands",
    "numLocations",
    "greenButton3",
    "text"
  ],

  cityLink: [
    "cityLink",
    "mapImg",
    "img",
    "cityH1",
    "numBrands",
    "numLocations",
    "greenButton3",
    "text"
  ],

  mapImg: ["mapImg", "img"],
  img: ["img"],
  cityH1: ["cityH1"],
  numBrands: ["numBrands"],
  numLocations: ["numLocations"],
  greenButton3: ["greenButton3", "text"],
  text: ["text"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicRadialSummary__ArgProps,
          internalVariantPropNames: PlasmicRadialSummary__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicRadialSummary__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicRadialSummary";
  } else {
    func.displayName = `PlasmicRadialSummary.${nodeName}`;
  }
  return func;
}

export const PlasmicRadialSummary = Object.assign(
  // Top-level PlasmicRadialSummary renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    cityLink: makeNodeComponent("cityLink"),
    mapImg: makeNodeComponent("mapImg"),
    img: makeNodeComponent("img"),
    cityH1: makeNodeComponent("cityH1"),
    numBrands: makeNodeComponent("numBrands"),
    numLocations: makeNodeComponent("numLocations"),
    greenButton3: makeNodeComponent("greenButton3"),
    text: makeNodeComponent("text"),
    // Metadata about props expected for PlasmicRadialSummary
    internalVariantProps: PlasmicRadialSummary__VariantProps,
    internalArgProps: PlasmicRadialSummary__ArgProps
  }
);

export default PlasmicRadialSummary;
/* prettier-ignore-end */
